export default function MaterialIcon(props) {
	return (
		<span data-tooltip={props.tooltip} onMouseDown={props.onMouseDown || null} onMouseUp={props.onMouseUp || null} style={props.style} onClick={props.onClick} className={"material-symbols-rounded" + (props.large ? " large" : "") + (props.tooltip ? " has-tooltip" : "") + (props.onClick ? " clickable" : "") + (props.className ? " " + props.className : "")}>
			{props.name}
		</span>
	);
}
